<template>
  <div>
    <div class="card-body">
        <b-table show-empty :items="administrations" :fields="fields" v-if="administrations" :empty-text="getEmptyText(count)" :busy="count == -1">
        <template v-slot:cell(actions)="row">
          <b-button v-b-modal.modalAdministration variant="themecolor" size="sm" @click.stop="loadModal(row.item)">
            <i class="fas fa-cog" aria-hidden="true"></i>
          </b-button>
        </template>
        <template v-slot:table-busy>
          <PreLoader/>
        </template>
      </b-table>
    </div>
    <!-- Modal Component -->
    <b-modal id="modalAdministration" ref="administrations" :title="`${$t('order.administratie')} ${command.id ? $t('klantrelaties.bewerker') : $t('klantrelaties.aanmaker')}`" 
      hide-footer centered cancel-title="Annuleren" ok-variant="themecolor" ok-title="Opslaan">
      <b-form @submit="onSubmit" autocomplete="off">
        <!-- Form content -->
        <b-form-group label="Tag" label-for="tag">
            <b-form-input disabled id="tag" v-model="command.tag" type="text" :placeholder="$t('fmbeheer.voereentagin')" />
            <validation element="tag" />
        </b-form-group>
        <b-form-group :label="$t('datatables.naam')" label-for="name">
            <b-form-input disabled id="name" v-model="command.name" type="text" :placeholder="$t('fmbeheer.voereennaamin')" />
            <validation element="name" />
        </b-form-group>
        <b-form-group :label="$t('fmbeheer.kiesEenKoppeling')" label-for="coupling">
            <b-form-select disabled id="coupling" v-model="command.coupling" :options="coupling"></b-form-select>
            <validation element="coupling" />
        </b-form-group>
        <p class="h5 mt-4">{{ $t('fmbeheer.mailInstellingen') }}</p>
        <b-form-group label-cols="4" :label="$t('fmbeheer.mailHostnaam')" label-for="mail-hostname">
            <b-form-input disabled id="mail-hostname" v-model="command.mailHostname" type="text" :placeholder="$t('fmbeheer.mailHostnaam')" />
            <validation element="mail-hostname" />
        </b-form-group>
        <b-form-group label-cols="4" :label="$t('fmbeheer.mailGebruikersnaam')" label-for="mail-username">
            <b-form-input disabled id="mail-username" v-model="command.mailUsername" type="text" :placeholder="$t('fmbeheer.mailGebruikersnaam')" />
            <validation element="mail-username" />
        </b-form-group>
        <b-form-group label-cols="4" :label="$t('fmbeheer.mailbox')" label-for="mail-is-active">
            <b-form-radio-group disabled id="mail-is-active" class="modal-radio" v-model="command.mailIsActive" :options="mailActivety" buttons button-variant="secondary">
            </b-form-radio-group>
            <validation element="mail-is-active" />
        </b-form-group>
        <!-- Form content -->
        <hr/>
        <!-- Submit controls -->
        <b-row>
            <b-col md="12">
                <b-button @click="$refs.administrations.hide()" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                <b-button disabled type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
            </b-col>
        </b-row>
        <!-- Submit controls -->
      </b-form>
    </b-modal>
    <!-- Modal Component -->
  </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

//Import command
import Command from './command'

export default {
    name: 'fm-administrations',
    components: {PreLoader},
    data () {
      return {
        command: {},
        count: -1,
        title: 'Administratie',
        mailActivety: [
            { text: this.$i18n.t('fmbeheer.mailNietActief'), value: false },
            { text: this.$i18n.t('fmbeheer.mailIsActief'), value: true }
        ]
      }
    },
    computed: {
      fields() { 
        return [
            { key: 'tag', label: 'Tag', sortable: true },
            { key: 'name', label: this.$i18n.t('datatables.naam'), sortable: true },
            { key: 'actions', label: this.$i18n.t('datatables.acties') }
        ]
      },
      ...mapGetters ('management',['administrations', 'coupling'])
    //   ...mapGetters('fm',['company', 'administrations','coupling']),
    },
    methods: {
      ...mapActions('management',['all','create','update','delete']),
    //   ...mapActions('fm',['all','create','update','delete']),
      loadModal(item) {
        var vm = this;
        vm.$store.dispatch('errors/clearErrors');
        vm.command = new Command(item);
      },
      onSubmit (event) {
        event.preventDefault();
        var vm = this;
        var payload = {
            resource: 'administrations',
            params: vm.command
        };
        
        var action = vm.command.id ? vm.update(payload) : vm.create(payload);
        action.then(()=> {
          vm.$refs.administrations.hide();
        })
      },
      getEmptyText,
    },
    created() {
      var vm = this;
      vm.all({
        resource: 'administrations'
      })
      .then((data) => {
        vm.count = data.result.length;
      });
    }
}
</script>